import { baseQuery } from '@/store/baseQuery';
import { dispatch } from '@/store/store';
import { setMfaExpired } from '@/store/slices/applicationSlice';

export const baseQueryWithStatusCheck = async (args: any, api: any, extraOptions: any) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    dispatch(setMfaExpired(true));
  }

  if (result.error && result.error.status === 429) {
    console.warn('Rate limit hit. Please slow down.');
  }

  // Handle 503 (cache warmup): wait and retry once
  if (result.error && result.error.status === 503) {
    const retryAfter = result.meta?.response?.headers?.get('Retry-After');
    const waitMs = (retryAfter ? parseInt(retryAfter, 10) : 5) * 1000;
    console.warn(`503 received, retrying after ${waitMs}ms`);
    await new Promise((resolve) => setTimeout(resolve, waitMs));
    return baseQuery(args, api, extraOptions);
  }

  return result;
};
